export const transportAutoEntryStatusLabels: Record<string, string> = {
  pending: 'Pendente',
  awaiting_ongoing_checkout: 'Aguardando checkout em andamento',
  in_transit: 'Em trânsito',
  completed: 'Concluído',
  canceled: 'Cancelado',
}
